export default __webpack_public_path__ + "static/media/background_mesh_mobile.eff4fa34.png";